import { State, addStateChangeListener, getState, removeStateChangeListener, } from '../../js/utils/applicationState';
function isOptedOutOfTargetingDefined() {
    const isOptedOutOfTargeting = getState(State.isOptedOutOfTargeting);
    return typeof isOptedOutOfTargeting === 'boolean';
}
export function waitForIsOptedOutOfTargeting() {
    if (isOptedOutOfTargetingDefined()) {
        return;
    }
    return new Promise((resolve) => {
        function onTargetingOptedOutReady() {
            if (isOptedOutOfTargetingDefined()) {
                removeStateChangeListener(State.isOptedOutOfTargeting, onTargetingOptedOutReady);
                resolve();
            }
        }
        addStateChangeListener(State.isOptedOutOfTargeting, onTargetingOptedOutReady);
    });
}
